import { render } from "./LinkGroupLinkUser.vue?vue&type=template&id=90086df2&ts=true"
import script from "./LinkGroupLinkUser.ts?vue&type=script&lang=ts&external"
export * from "./LinkGroupLinkUser.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__